import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import styled from "styled-components";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Container>
      <Box>
        <h1>404</h1>
        <p>Oops! Page not found</p>
        <a href="/">
          Return to Home
        </a>
      </Box>
    </Container>
  );
};

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh
`;
const Box = styled.div`
  text-align: center;
`;


export default NotFound;
